import { FC } from 'react';

import {
  useLmmOpenBenodigdOpbouw,
  useLmmOpenTijdstip,
  useLmmTijdstippen,
} from '@/apps/lmm/state/selectors/useLmmVoorraadStore';

import { LmmMaterieelTimed, LmmTijdstip, LmmVerrijktV2 } from '../../types/LmmVoorraad';
import { getLmmTijdstipColumns, LmmColumnKey } from '../../utils/lmmTableColumns';
import LmmSidepanelToggle from '../LmmSidepanel/LmmSidepanelToggle';

import LmmOverTekortTooltip from './LmmOverTekortTooltip';

import styles from './LmmTableMaterieelRow.module.css';

type LmmTableMaterieelRowProps = {
  materieel: string;
  materieelTimed: LmmMaterieelTimed;
};

const renderColumnValue = (columnKey: LmmColumnKey, voorraad: LmmVerrijktV2, tijdstip: LmmTijdstip) => {
  switch (columnKey) {
    case 'benodigd':
      return voorraad.benodigd.dienst + voorraad.benodigd.gdst + voorraad.benodigd.ebksb;
    case 'dienst':
      return voorraad.benodigd.dienst;
    case 'gdst':
      return voorraad.benodigd.gdst;
    case 'ebksb':
      return voorraad.benodigd.ebksb;
    case 'nietInzetbaar':
      return voorraad.nietInzetbaar.aantalEenheden;
    case 'verwachtNietInzetbaar':
      return voorraad.nietInzetbaar.aantalEenheden;
    case 'verwachtGereed':
      return voorraad.verwachtGereed.aantalEenheden;
    case 'overOfTekort':
      return <LmmOverTekortTooltip voorraad={voorraad} tijdstip={tijdstip} />;
    default:
      return null;
  }
};

const LmmTableMaterieelRow: FC<LmmTableMaterieelRowProps> = ({ materieel, materieelTimed }) => {
  const lmmTijdstippen = useLmmTijdstippen();
  const lmmOpenTijdstip = useLmmOpenTijdstip();
  const lmmOpenBenodigdOpbouw = useLmmOpenBenodigdOpbouw();

  const brutoPark = materieelTimed?.NU.brutoPark;

  return (
    <div data-testid={`lmmMaterieelRow_${materieel}`} className={styles.tableRow}>
      <div className={[styles.cell, styles.matsoortCell].join(' ')}>{materieel}</div>
      <div data-testid={`lmmMaterieelBrutoPark_${materieel}`} className={[styles.cell, styles.brutoParkCell].join(' ')}>
        {brutoPark}
      </div>
      {lmmTijdstippen.map((tijdstip) => {
        const columns = getLmmTijdstipColumns(tijdstip.label, lmmOpenTijdstip, lmmOpenBenodigdOpbouw);
        const voorraad = materieelTimed?.[tijdstip.label.toUpperCase()];
        if (!voorraad) return null;
        return (
          <LmmSidepanelToggle
            key={tijdstip.label}
            lmmVoorraad={voorraad}
            lmmTijdstip={tijdstip}
            className={styles.tijdstipGroup}
            style={{ flexGrow: columns.length }}
          >
            {columns.map((columnKey) => (
              <div key={columnKey} className={styles.cell}>
                {renderColumnValue(columnKey, voorraad, tijdstip)}
              </div>
            ))}
          </LmmSidepanelToggle>
        );
      })}
    </div>
  );
};
export default LmmTableMaterieelRow;
